import { div, span, fnstate } from '@srfnstack/fntags'

// Five-star rating widget for a generated asset. Posts to /api/assets/:id/rate
// on click; clicking the current rating again clears it. Ratings are graded
// taste labels for the autopilot feedback loop — 5 stars tunes generation
// toward a design much harder than a plain approve.
export const StarRating = ({ assetId, initial = null, onRated = null }) => {
  const rating = fnstate(initial || 0)

  const setRating = async (n) => {
    const next = n === rating() ? null : n
    try {
      const res = await fetch(`/api/assets/${assetId}/rate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rating: next })
      })
      if (!res.ok) return
      rating(next || 0)
      if (onRated) onRated(next)
    } catch { /* leave the previous rating on network failure */ }
  }

  return rating.bindAs(r =>
    div({ class: 'flex items-center select-none', style: '-webkit-touch-callout: none', title: r ? `Rated ${r}/5 — click same star to clear` : 'Rate this design' },
      ...[1, 2, 3, 4, 5].map(n => span({
        class: `material-symbols-rounded cursor-pointer !text-[48px] leading-none transition-colors ${n <= r ? 'text-warning' : 'opacity-30 hover:opacity-70'}`,
        style: n <= r ? "font-variation-settings: 'FILL' 1" : '',
        onclick: (e) => {
          e.stopPropagation()
          setRating(n)
        }
      }, 'star'))
    )
  )
}
